import React from "react";
import "../assets/styles/Spinner.css"; // Import styling for spinner

const Spinner = () => {
    return (
        <div className="spinner-container">
            <div className="spinner"></div>
        </div>
    );
};

export default Spinner;
